import ChevronDownIcon from '@images/chevron-bottom.svg?react';

import { StyledCardHeaderExpand, StyledCardHeaderExpandButton } from './CardExpandButton.styles';

interface CardExpandButtonProps {
  isExtended: boolean;
  onExtendedToggle: () => void;
}

export const CardExpandButton = (props: CardExpandButtonProps) => {
  const { isExtended, onExtendedToggle } = props;

  return (
    <StyledCardHeaderExpand>
      <StyledCardHeaderExpandButton isExtended={isExtended} onClick={onExtendedToggle}>
        <ChevronDownIcon data-testid={isExtended ? 'chevronTop' : 'chevronDown'} />
      </StyledCardHeaderExpandButton>
    </StyledCardHeaderExpand>
  );
};
